@if (parentFormGroup &&
  parentFormGroup.controls &&
  parentFormGroup.controls[this.controlName]) {
  <div
    class="text-area-container"
    [formGroup]="parentFormGroup"
    >
    <!-- Label outside the bordered box per Figma design -->
    @if (label) {
      <label class="text-area-label">{{ label }}:@if (labelBadge) { <span class="field-label-badge" data-testid="field-label-badge">{{ labelBadge }}</span> }</label>
    }
    <!-- Bordered textarea -->
    <!-- attr.maxlength (not maxlength) on purpose: the native attribute still caps
         what the user can type/paste, but it does NOT pull in Angular's
         MaxLengthValidator. Records created on mobile have no such cap, so a
         value longer than maxLength would otherwise make the control — and the
         whole form — permanently invalid, leaving Save greyed out with no error. -->
    <textarea
      #textarea
      [formControlName]="controlName"
      [attr.maxlength]="effectiveMaxLength"
      [ngClass]="{'hide-error-box': hideErrorBox, 'has-error': error}"
      class="text-area-input"
      placeholder="{{placeholder}}"
      rows="4"
    ></textarea>
    @if (error) {
      <div class="text-area-error">{{ error }}</div>
    }
    @if (showCharCount) {
      <div
        class="char-count flex w-full justify-end items-center mt-[0.5rem]"
        >
        <!-- effectiveMaxLength, not maxLength: when the cap has been dropped for an
             already-over-length value there is no limit to count against, so show
             the bare count rather than a total the field no longer enforces. -->
        {{ (parentFormGroup?.controls[controlName]?.value?.length || 0)
        }}{{ effectiveMaxLength ? '/' + effectiveMaxLength : '' }}
      </div>
    }
  </div>
}
